import { format } from 'date-fns';

import {
  GiftCardTransaction,
  GiftCardTransactionChannel,
  GiftCardTransactionType,
} from './types';

export function maskCardNumber({
  lastDigits,
  totalDigits = 16,
}: {
  lastDigits: string;
  totalDigits?: number;
}) {
  const maskedLength = totalDigits - lastDigits.length;
  const masked = '•'.repeat(maskedLength) + lastDigits;
  return masked.replace(/(.{4})/g, '$1 ').trim();
}

export function formatCardNumber(cardNumber: string) {
  return cardNumber?.replace(/(.{4})/g, '$1 ').trim();
}

export function formatDate(date: Date) {
  return format(date, 'MMMM dd, yyyy - hh:mm aa');
}

export function formatCentsToDollarString(cents: number = 0, precision = 2) {
  return (cents / 100).toFixed(precision);
}

export type TransactionDisplay = {
  id: string;
  type: GiftCardTransactionType;
  amount: number;
  description: string;
  date: string;
};

function getTransactionDescription(
  type: GiftCardTransactionType,
  transactionChannel: GiftCardTransactionChannel
): string {
  switch (type) {
    case GiftCardTransactionType.Reload:
      return 'Funds Reload';
    case GiftCardTransactionType.Purchase:
      switch (transactionChannel) {
        case GiftCardTransactionChannel.IN_RESTAURANT:
          return 'Restaurant Order';
        case GiftCardTransactionChannel.DIGITAL:
          return 'Digital Order';
        default:
          return type;
      }
    default:
      return type;
  }
}

export function transformTransaction(
  transaction: GiftCardTransaction,
  index: number
): TransactionDisplay {
  return {
    id: `${transaction.date}-${index}`,
    type: transaction.type,
    amount: transaction.amount,
    description: getTransactionDescription(transaction.type, transaction.transactionChannel),
    date: transaction.date,
  };
}

export function groupTransactionsByMonth(
  transactions: GiftCardTransaction[]
): Record<string, TransactionDisplay[]> {
  const grouped: Record<string, TransactionDisplay[]> = {};

  transactions.forEach((transaction, index) => {
    const date = new Date(transaction.date);
    const monthYear = format(date, 'MMMM yyyy');

    if (!grouped[monthYear]) {
      grouped[monthYear] = [];
    }

    grouped[monthYear].push(transformTransaction(transaction, index));
  });

  return grouped;
}
